import React, { useEffect, useState, useCallback } from 'react';
import {
  Container,
  Row,
  Col,
  Button,
  Spinner,
  Alert
} from 'reactstrap';
import { useLocation, useNavigate, Link } from 'react-router-dom';
import Breadcrumbs from "components/Common/Breadcrumb";
// --- UBAH IMPORT API: Sesuaikan dengan service baru yang di-rename ---
import { fetchJenisSeleksiByParentID } from '../../../services/Master/MasterJenisSeleksi'; 

import {
  FiList, FiAlertCircle, FiUsers, FiBookOpen,
  FiBriefcase, FiShield, FiTarget,
  FiArrowLeft, FiFileText, FiArrowRight,
} from 'react-icons/fi';

import bg3 from '../../../assets/images/bg3.png';

const SubVideoDetail = () => {
  document.title = "Sub Paket Video"; // Mengganti judul dokumen
  const location = useLocation();
  const navigate = useNavigate();

  const [masterPaketList, setMasterPaketList] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [parentName, setParentName] = useState(''); // State untuk nama parent, misal: 'CPNS', 'Kedinasan'

  const params = new URLSearchParams(location.search);
  // --- AMBIL PARAMETER DARI URL: id_jenis_seleksi adalah yang utama ---
  const idJenisSeleksi = params.get('id_jenis_seleksi'); 
  const idTipeKonten = params.get('id_tipe_konten'); 
  const tipe = params.get('kategori_paket'); 
  // idPaket tidak relevan untuk halaman ini, karena kita mencari daftar sub-paket
  // const idPaket = params.get('id_paket'); 

  const fetchPaketData = useCallback(async (jenisSeleksiId, idTipeKonten) => { // Mengubah nama fungsi untuk lebih jelas
    try {
      setLoading(true);
      setError(null);
      
      // --- UBAH PANGGILAN API SESUAI DENGAN DEFINISI SERVICE fetchJenisSeleksiByParentID ---
      const response = await fetchJenisSeleksiByParentID(jenisSeleksiId, idTipeKonten, {
        disable_pagination: true, // Ambil semua data tanpa paginasi
      });

      if (response.success && Array.isArray(response.data)) {
        setMasterPaketList(response.data);
        // Ambil nama parent dari data pertama jika ada
        if (response.data.length > 0 && response.data[0].jenis_seleksi_name) {
            setParentName(response.data[0].jenis_seleksi_name);
        } else {
            // Jika tidak ada nama jenis seleksi di data paket, gunakan fallback
            setParentName('Sub-Paket Simulasi'); 
        }
      } else {
        setError(response.message || 'Gagal memuat daftar sub-paket.');
        setMasterPaketList([]);
      }
    } catch (err) {
      setError(err.message || 'Terjadi kesalahan saat memuat daftar sub-paket.');
      setMasterPaketList([]);
    } finally {
      setLoading(false);
    }
  }, []); // Dependensi kosong karena fetchJenisSeleksiByParentID diimport, tidak perlu di sini

  useEffect(() => {
    // --- CEK PARAMETER id_jenis_seleksi ---
    if (idJenisSeleksi) {
      const parsedId = parseInt(idJenisSeleksi, 10);
      const parseIDTipeKonten = parseInt(idTipeKonten, 10);
      if (!isNaN(parsedId) && parsedId > 0) {
        fetchPaketData(parsedId,parseIDTipeKonten);
      } else {
        setLoading(false);
        setError("Parameter 'id_jenis_seleksi' di URL tidak valid. Pastikan itu angka positif.");
      }
    } else {
      setLoading(false);
      setError("Parameter 'id_jenis_seleksi' tidak ditemukan di URL. Pastikan URL berbentuk `/sub-simulasi?id_jenis_seleksi=ID_JENIS_SELEKSI`.");
    }
  }, [idJenisSeleksi, fetchPaketData]); // Dependensi: idJenisSeleksi & fetchPaketData (jika callback)

  const getJenisSeleksiStyling = (seleksiName) => { 
    let icon = <FiList />; // Default icon
    let color = '#007bff';
    let overlayColor = 'rgba(230, 247, 255, 0.9)';
    let personImageUrl = "https://via.placeholder.com/120x150/ADD8E6/FFFFFF?text=Sim";

    const lowerSeleksi = seleksiName ? seleksiName.toLowerCase() : '';

    if (lowerSeleksi.includes('cpns')) {
      icon = <FiUsers />; color = '#28a745'; overlayColor = 'rgba(234, 247, 235, 0.9)'; personImageUrl = "https://via.placeholder.com/120x150/90EE90/FFFFFF?text=CPNS";
    } else if (lowerSeleksi.includes('pppk')) {
      icon = <FiBriefcase />; color = '#6f42c1'; overlayColor = 'rgba(242, 232, 250, 0.9)'; personImageUrl = "https://via.placeholder.com/120x150/DDA0DD/FFFFFF?text=PPPK";
    } else if (lowerSeleksi.includes('kedinasan')) {
      icon = <FiBookOpen />; color = '#fd7e14'; overlayColor = 'rgba(255, 243, 230, 0.9)'; personImageUrl = "https://via.placeholder.com/120x150/FFDAB9/FFFFFF?text=Kdn";
    } else if (lowerSeleksi.includes('bumn')) {
      icon = <FiBriefcase />; color = '#6f42c1'; overlayColor = 'rgba(242, 232, 250, 0.9)'; personImageUrl = "https://via.placeholder.com/120x150/DDA0DD/FFFFFF?text=BUMN";
    } else if (lowerSeleksi.includes('polri')) {
      icon = <FiShield />; color = '#004a7c'; overlayColor = 'rgba(224, 236, 242, 0.9)'; personImageUrl = "https://via.placeholder.com/120x150/B0E0E6/FFFFFF?text=POLRI";
    } else if (lowerSeleksi.includes('tni')) {
      icon = <FiTarget />; color = '#800000'; overlayColor = 'rgba(247, 224, 224, 0.9)'; personImageUrl = "https://via.placeholder.com/120x150/CD5C5C/FFFFFF?text=TNI";
    }
    return { icon, color, overlayColor, personImageUrl };
  };

  const { color, overlayColor, personImageUrl } = getJenisSeleksiStyling(parentName);

  const getBreadcrumbPaddingTop = () => {
    if (window.innerWidth <= 767.98) { return '70px'; }
    if (window.innerWidth <= 991.98) { return '80px'; }
    return '100px';
  };

  if (loading) {
    return (
      <div className="page-content" style={{ minHeight: 'calc(100vh - 100px)' }}>
        <Container fluid style={{ paddingTop: getBreadcrumbPaddingTop() }}>
          <Breadcrumbs title="Daftar Paket" breadcrumbItem={`Memuat Paket...`} />
          <div className="d-flex justify-content-center align-items-center" style={{ minHeight: '300px' }}>
            <Spinner color="primary" />
            <span className="ms-2">Memuat daftar paket...</span>
          </div>
        </Container>
      </div>
    );
  }

  if (error) {
    return (
      <div className="page-content" style={{ minHeight: 'calc(100vh - 100px)' }}>
        <Container fluid style={{ paddingTop: getBreadcrumbPaddingTop() }}>
          <Breadcrumbs title="Daftar Paket" breadcrumbItem="Error" />
          <Alert color="danger" className="text-center">
            <FiAlertCircle className="me-2" size={20} />
            <strong>Terjadi Kesalahan:</strong> {error}
            <div className="mt-3">
              <Button color="danger" outline onClick={() => navigate(-1)}>
                <FiArrowLeft className="me-1" /> Kembali
              </Button>
            </div>
          </Alert>
        </Container>
      </div>
    );
  }

  if (masterPaketList.length === 0) {
    return (
      <div className="page-content" style={{ minHeight: 'calc(100vh - 100px)' }}>
        <Container fluid style={{ paddingTop: getBreadcrumbPaddingTop() }}>
          <Breadcrumbs title="Daftar Paket" breadcrumbItem="Tidak Ditemukan" />
          <Alert color="warning" className="text-center">
            <FiAlertCircle className="me-2" size={20} />
            Tidak ada paket ditemukan untuk jenis seleksi ini.
            <div className="mt-3">
              <Button color="warning" outline onClick={() => navigate(-1)}>
                <FiArrowLeft className="me-1" /> Kembali
              </Button>
            </div>
          </Alert>
        </Container>
      </div>
    );
  }

  return (
    <div className="page-content">
      <Container fluid className="breadcrumb-and-content-wrapper">
        <Breadcrumbs title="Paket" breadcrumbItem={parentName || `Sub Paket`} />

        <div className="main-cards-section">
            <Row className="gy-4">
              {masterPaketList.map(paket => (
                <Col xs={12} sm={6} md={4} key={paket.id_paket}>
                  <div
                    className="paket-bidang-item-new h-100"
                    style={{
                      backgroundImage: `url(${bg3}), url(${personImageUrl})`,
                      backgroundPosition: 'center, right bottom',
                      backgroundSize: 'cover, 120px 150px',
                      backgroundRepeat: 'no-repeat',
                    }}
                  >
                    <div className="paket-bidang-main-content">
                      <div className="paket-bidang-text-area">
                        <h5 className="mb-2 fw-bold" style={{ color: color }}>{paket.nama_seleksi}</h5>
                        <p className="text-muted mb-0 font-size-15">
                          {paket.deskripsi && <span className="d-block">{paket.deskripsi}</span>}
                        </p>
                      </div>
                      <div className="paket-bidang-button-area">
                      <Button
                        tag={Link}
                        to={`/list-video?id_tipe_konten=${idTipeKonten}&id_jenis_seleksi=${paket.id_jenis_seleksi}&kategori_paket=${tipe}`}
                        color="primary"
                        className="btn-kerjakan"
                      >
                        {paket.id_tipe_konten === 4 ? "Lihat Video" : "Lihat Video"} 
                        <FiArrowRight className="ms-1" />
                      </Button>
                      </div>
                    </div>
                  </div>
                </Col>
              ))}
            </Row>
        </div>
      </Container>

      <style>
        {`
          .page-content {
            background-color: #f0f2f5;
            padding-bottom: 80px;
            min-height: calc(100vh - var(--footer-height, 0px));
            display: flex;
            flex-direction: column;
          }
          .breadcrumb-and-content-wrapper {
            margin-top: 10px;
            flex-grow: 1;
          }
          .main-cards-section {
            margin-top: 2rem;
          }
          .main-content-wrapper {
            background-color: #fff;
            border-radius: 15px;
            box-shadow: 0 4px 20px rgba(0,0,0,0.05);
            position: relative;
            z-index: 1;
            padding: 24px;
          }
          /* New Card Styling */
          .paket-bidang-item-new {
            background-color: #fff;
            border-radius: 15px;
            overflow: hidden;
            box-shadow: 0 4px 12px rgba(0,0,0,0.08);
            border: 1px solid #e0e0e0;
            transition: transform 0.2s ease-in-out, box-shadow 0.2s ease-in-out;
            height: 100%;
            display: flex;
            align-items: stretch;
            justify-content: flex-start;
            position: relative;
            z-index: 2;
          }
          .paket-bidang-item-new:hover {
            transform: translateY(-7px);
            box-shadow: 0 8px 20px rgba(0,0,0,0.15);
          }
          .paket-bidang-main-content {
            flex-grow: 1;
            padding: 2.2rem;
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            min-width: 0;
            position: relative;
            z-index: 1;
          }
        .paket-bidang-main-content::before {
            content: '';
            position: absolute;
            top: 0;
            left: 0;
            right: 120px;
            bottom: 0;
            border-radius: 15px 0 0 15px;
            z-index: -1;
          }
          .paket-bidang-text-area {
            margin-bottom: 1.2rem;
          }
          .paket-bidang-text-area h5 {
            font-size: 1.25rem;
            margin-bottom: 0.6rem;
            font-weight: 700;
            line-height: 1.3;
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 2;
            -webkit-box-orient: vertical;
            white-space: normal;
            color: #007bff;
          }
          .paket-bidang-text-area p {
            font-size: 1.05rem;
            line-height: 1.6;
            color: #555;
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 3;
            -webkit-box-orient: vertical;
            white-space: normal;
          }
          .paket-bidang-button-area .btn-kerjakan {
            font-size: 0.9rem;
            padding: 0.7rem 1.2rem;
            border-radius: 8px;
            font-weight: 600;
            width: auto;
            align-self: flex-start;
          }
          .paket-bidang-button-area .btn-kerjakan:hover {
            transform: translateY(-2px);
          }
          /* Responsive Adjustments */
          @media (max-width: 991.98px) {
            .breadcrumb-and-content-wrapper {
              margin-top: 10px;
            }
            .paket-bidang-item-new {
              flex-direction: column;
              text-align: center;
              background-position: center bottom;
              background-size: cover, 100px 125px;
            }
            .paket-bidang-main-content {
              padding: 1.8rem;
              border-radius: 15px 15px 0 0;
              width: 100%;
            }
            .paket-bidang-main-content::before {
              border-radius: 15px 15px 0 0;
              right: 0;
            }
            .paket-bidang-button-area {
                width: 100%;
                display: flex;
                justify-content: center;
            }
            .paket-bidang-text-area h5,
            .paket-bidang-text-area p {
                -webkit-line-clamp: unset;
                white-space: normal;
            }
          }
          @media (max-width: 767.98px) {
            .breadcrumb-and-content-wrapper {
              margin-top: 10px;
            }
            .paket-bidang-text-area h5 {
              font-size: 1.1rem;
            }
            .paket-bidang-text-area p {
              font-size: 0.95rem;
            }
            .paket-bidang-button-area .btn-kerjakan {
              font-size: 0.85rem;
              padding: 0.6rem 1rem;
            }
            .page-content {
              padding-bottom: 60px;
            }
          }
        `}
      </style>
    </div>
  );
};

export default SubVideoDetail;